import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "text-darkGray-1" }
const _hoisted_2 = { class: "flex flex-col gap-2 my-4" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = {
  key: 1,
  class: "text-red-2 mt-2"
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col gap-2 my-4"
}
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col gap-2 my-4"
}
const _hoisted_9 = { class: "flex flex-col gap-2 my-4" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "text-red-2"
}
const _hoisted_12 = {
  key: 2,
  class: "flex flex-col gap-2 my-4"
}
const _hoisted_13 = ["innerHTML"]

import { Profile } from "@/models/Profile";
import { anyTypeAnnotation } from "@babel/types";
import { onMounted } from "vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerGdpRrekryteringslots',
  props: {
  company: {
    type: Profile,
    required: true
  },
},
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("em", null, " Gäller fr.o.m den 31 januari 2022 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-lg font-bold" }, "Personuppgiftsansvarig", -1)),
      _createElementVNode("p", _hoisted_3, [
        _cache[3] || (_cache[3] = _createTextVNode(" Personuppgiftsansvarig för behandlingen såvitt gäller innehållet i Din ansökan i Ansökningsportal.se är: ", -1)),
        (props?.company?.DisplayName?.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(props?.company?.DisplayName?.data) + " ", 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-normal" }, "(nedan kallat \"Bolaget\")", -1))
              ]),
              _createElementVNode("p", null, _toDisplayString(props?.company?.OrganisationNumber.data), 1),
              _createElementVNode("p", null, _toDisplayString(props?.company?.Address?.data), 1),
              _createElementVNode("p", null, _toDisplayString(props?.company?.ZipCode?.data) + " " + _toDisplayString(props?.company?.City?.data), 1),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, null, -1)),
              _createElementVNode("p", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-normal" }, "Kontaktuppgift: ", -1)),
                _createTextVNode(_toDisplayString(props?.company?.GdprContact.data || ''), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_6, "Uppgift saknas"))
      ])
    ]),
    _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"flex flex-col gap-2 my-4\"><h2 class=\"text-lg font-bold\">Ändamål</h2><p class=\"\"> Personuppgifterna används för arbetssökandes kontakter med Bolaget och läggs till grund för manuella beslut i rekryteringsärenden. Uppgifterna kan även användas i personalliggare, i samband med ansökningar om sponsring. </p></div><div class=\"flex flex-col gap-2 my-4\"><h2 class=\"text-lg font-bold\">Den rättsliga grunden för behandlingen</h2><p class=\"\">Behandlingens rättsliga grund är <em>samtycke</em>.</p></div>", 2)),
    (props?.company?.Container?.DTO?.id !== 393)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("h2", { class: "text-lg font-bold" }, "Mottagare", -1),
          _createElementVNode("p", { class: "" }, " De mottagare som ska ta del av personuppgifterna är rekryteringsansvariga, HR-ansvariga och/eller ansvariga för beslut om sponsring. Personuppgifter lämnas endast ut till andra bolag om det behövs på grund av gällande rätt, för att skydda Bolagets/tredje parts rättigheter. ", -1)
        ]))]))
      : (props?.company?.Container?.DTO?.id === 393)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("h2", { class: "text-lg font-bold" }, "Mottagare", -1),
            _createElementVNode("p", { class: "" }, " De mottagare som ska ta del av personuppgifterna är rekryteringsansvariga hos bolaget och dess medlemsföretag, HR-ansvariga och/eller ansvariga för beslut om sponsring. Personuppgifter lämnas endast ut till andra bolag om det behövs på grund av gällande rätt, för att skydda Bolagets/tredje parts rättigheter. ", -1)
          ]))]))
        : _createCommentVNode("", true),
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex flex-col gap-2 my-4" }, [
      _createElementVNode("h2", { class: "text-lg font-bold" }, "Lagringstid"),
      _createElementVNode("p", { class: "" }, " Personuppgifterna lagras under maximalt 36 månaders tid från att Bolaget eller registrerade har tillfört Bolaget personuppgifterna. Personuppgifterna sparas aldrig längre än vad som är nödvändigt för respektive ändamål. ")
    ], -1)),
    _createElementVNode("div", _hoisted_9, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-lg font-bold" }, "Dina rättigheter", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "" }, " Som registrerad har Du rätt att av Bolaget utan kostnad begära tillgång till, och rättelse eller radering av, personuppgifter eller begränsning av behandling som rör Dig eller att invända mot behandling samt dataportabilitet. Vissa uppgifter kan inte raderas om de måste sparas enligt gällande rätt. ", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("p", null, " Du har rätt att när som helst återkalla Ditt samtycke till behandlingen, utan att detta påverkar lagligheten av behandlingen på grundval av samtycket, innan detta återkallades. Om det finns ett annat avtal som Du blir del av indirekt när Du lämnar samtycket kan inte samtycket återkallas direkt utan att det först tas hänsyn till avtalet. ", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("p", null, "Begäran enligt ovan ska skriftligen skickas till:", -1)),
      (props?.company?.GdprAddress.data)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "font-semibold",
            innerHTML: props?.company?.GdprAddress.data
          }, null, 8, _hoisted_10))
        : (_openBlock(), _createElementBlock("p", _hoisted_11, "Uppgift saknas")),
      _cache[11] || (_cache[11] = _createElementVNode("p", null, [
        _createTextVNode("Du har rätt att ge in klagomål till "),
        _createElementVNode("a", {
          href: "https://www.imy.se/privatperson/utfora-arenden/lamna-ett-klagomal/",
          target: "_blank",
          class: "text-blue-1 underline"
        }, "Integritetsskyddsmyndigheten.")
      ], -1)),
      _cache[12] || (_cache[12] = _createElementVNode("p", null, " Ditt tillhandahållande av personuppgifter är ett krav som är nödvändigt för att framgent kunna ingå avtal med Bolaget. En följd av att inte lämna personuppgifter, eller att återkalla ett lämnat samtycke, är att Bolaget inte kan erbjuda tjänsten, de möjligheter som tjänsten innebär eller tillhandahålla ytterligare information. ", -1))
    ]),
    (props?.company?.Container?.DTO?.id === 393)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-lg font-bold" }, "Våra medlemsföretag", -1)),
          _createElementVNode("div", {
            innerHTML: props.company.Members.data
          }, null, 8, _hoisted_13)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})